import { tss } from 'tss-react/mui';

const useStyles = tss
  .withParams<{
    hasNetwork: boolean;
    hasLog: boolean;
    selectedOrganizationLabel: string;
  }>()
  .create(({ theme, hasNetwork, hasLog, selectedOrganizationLabel }) => ({
    dashboardPage: {
      display: 'grid',
      gridTemplateColumns: 'repeat(12, minmax(0, 1fr))',
      gridTemplateRows: 'repeat(5, minmax(8rem, 1fr))',
      gap: '1.5rem',
      height: '100%',
      [theme.breakpoints.down('xl')]: {
        gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
        gridTemplateRows: 'repeat(12, minmax(200px, 1fr))'
      },
      [theme.breakpoints.down('md')]: {
        gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
        gridTemplateRows: 'repeat(11, minmax(auto, 300px))'
      }
    },
    dashboardFullWidthItem: {
      height: '100%',
      width: '100%',
      gridRow: 'span 2',
      gridColumn: 'span 12',
      [theme.breakpoints.down('xl')]: {
        gridColumn: 'span 4'
      },
      [theme.breakpoints.down('md')]: {
        gridColumn: 'span 2',
        gridRow: 'span 1',
        minHeight: '18rem'
      }
    },
    dashboardMediumItem: {
      height: '100%',
      width: '100%',
      gridRow: 'span 2',
      gridColumn: 'span 4',
      [theme.breakpoints.down('xl')]: {
        gridColumn: 'span 4'
      },
      [theme.breakpoints.down('md')]: {
        gridColumn: 'span 2',
        gridRow: 'span 1',
        minHeight: '18rem'
      }
    },
    dashboardCaseTitleGraph: {
      height: '100%',
      width: '100%',
      gridRow: 'span 2',
      gridColumn: 'span 12',
      [theme.breakpoints.down('xl')]: {
        gridColumn: 'span 4'
      },
      [theme.breakpoints.down('md')]: {
        gridColumn: 'span 2',
        gridRow: 'span 1',
        minHeight: '18rem'
      }
    },
    dashboardSmallItem: {
      height: '100%',
      width: '100%',
      gridRow: 'span 1',
      gridColumn:
        (hasNetwork && hasLog) || selectedOrganizationLabel === 'all'
          ? 'span 3'
          : 'span 6',
      [theme.breakpoints.down('xl')]: {
        gridColumn:
          (hasNetwork && hasLog) || selectedOrganizationLabel === 'all'
            ? 'span 1'
            : 'span 2'
      },
      [theme.breakpoints.down('md')]: {
        gridColumn: 'span 1',
        gridRow: 'span 1',
        minHeight: '18rem'
      }
    },
    smallCardText: {
      fontSize: 'clamp(25px, 40px, 55px)'
    }
  }));

export default useStyles;
